import { useState } from "react";
import { api } from "@/lib/api";
import { useData } from "@/lib/data";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Building2, Check, X } from "lucide-react";
import { toast } from "sonner";

// Pick a sole supplier card, or create one inline
export default function SupplierPicker({ value, onChange, testId = "supplier" }) {
  const { suppliers, refreshSuppliers } = useData();
  const [creating, setCreating] = useState(false);
  const [form, setForm] = useState({ name: "", contact_name: "", phone: "" });

  const create = async () => {
    if (!form.name.trim()) { toast.error("Firma adı zorunlu"); return; }
    try {
      const r = await api.post("/suppliers", form);
      await refreshSuppliers();
      onChange(r.data.id, r.data);
      toast.success("Taban firması oluşturuldu");
      setCreating(false); setForm({ name: "", contact_name: "", phone: "" });
    } catch (e) { toast.error(e.response?.data?.detail || "Hata"); }
  };

  if (creating) {
    return (
      <div className="rounded-md border border-[#D97706]/50 bg-[#EFE6D6] p-3 space-y-2" data-testid={`${testId}-quick-form`}>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
          {[["name", "Firma adı *"], ["contact_name", "Yetkili"], ["phone", "Telefon"]].map(([f, ph]) => (
            <Input key={f} placeholder={ph} value={form[f]} data-testid={`${testId}-quick-${f}`}
              onChange={(e) => setForm({ ...form, [f]: e.target.value })} className="h-10 bg-[#FFFBF4] border-[#DCCFB8]" />
          ))}
        </div>
        <div className="flex justify-end gap-2">
          <Button type="button" variant="outline" onClick={() => setCreating(false)} data-testid={`${testId}-quick-cancel`}
            className="h-9 border-[#DCCFB8] bg-transparent text-[#6B5B4A]"><X className="w-4 h-4 mr-1" /> Vazgeç</Button>
          <Button type="button" onClick={create} data-testid={`${testId}-quick-save`} className="h-9 bg-[#D97706] hover:bg-[#B45309] text-white">
            <Check className="w-4 h-4 mr-1" /> Kaydet ve Seç</Button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex gap-2">
      <Select value={value} onValueChange={(v) => onChange(v, suppliers.find((x) => x.id === v))}>
        <SelectTrigger data-testid={`${testId}-select`} className="h-11 bg-[#EFE6D6] border-[#DCCFB8] flex-1">
          <SelectValue placeholder="Taban firması seçin..." />
        </SelectTrigger>
        <SelectContent className="bg-[#FFFBF4] border-[#DCCFB8] text-[#2B2118]">
          {suppliers.length === 0 && <div className="px-3 py-2 text-sm text-[#8C7B68]">Firma kartı yok</div>}
          {suppliers.map((s) => (
            <SelectItem key={s.id} value={s.id} data-testid={`${testId}-option-${s.id}`}>
              {s.name}{s.contact_name ? ` · ${s.contact_name}` : ""}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Button type="button" variant="outline" onClick={() => setCreating(true)} data-testid={`${testId}-new-btn`}
        className="h-11 border-[#DCCFB8] bg-[#EFE6D6] text-[#B45309] hover:bg-[#FFFBF4] hover:text-[#B45309]">
        <Building2 className="w-4 h-4 mr-1" /> Firma Oluştur
      </Button>
    </div>
  );
}
